import {makeGetRequest} from "@/helper/requests";
import choices from "@/urls/choices";
import selectors from "@/urls/selectors";
import {sendGetRequest} from "@/helper/requests";

function loadSelector(url, {commit, getters}, selector, finalizer=()=>{}, force=false) {
  /**
   * Вспомогательная функция для загрузки селекторов с кэшированием
   * @param {string} url - URL для загрузки данных селектора
   * @param {string} selector - Имя селектора
   * @param {Function} finalizer - Функция-обработчик успешной загрузки
   * @param {boolean} force - Принудительная перезагрузка, игнорируя кэш
   */
    let getFunction = `get${selector}Selector`;
    let setFunction = `set${selector}Selector`;
    let isFunction = `isLoading${selector}Selector`;
    let setLoading = `setIsLoading${selector}Selector`;
    let setNotLoading = `setIsNotLoading${selector}Selector`;
    if (force || (getters[getFunction].length === 0 && !getters[isFunction])) {
        commit(setLoading);
        makeGetRequest(
            url
        ).then(resp => {
            return resp.json()
        }).then(json => {
            commit(setFunction, json);
            commit(setNotLoading);
            finalizer(json);
        })
    } else {
        finalizer(getters[getFunction]);
    }
}



const state = {
    selectors: {
        kind: [],
        anonymity: [],
        field_type: [],
        date_value: [],
        coherent: [],
        fields: [],
        admin_fields: [],
        admin_choices: [],
        creator_fields: [],
        creator_choices: [],
        document: [],
    },
    loading: {
        kind: false,
        document: false,
        anonymity: false,
        field_type: false,
        date_value: false,
        coherent: false,
        fields: false,
        admin_fields: false,
        admin_choices: false,
        creator_fields: false,
        creator_choices: false,
    },
    kind_types: [],
    anonymity_types: [],
    field_types: [],
    date_value_types: [],
    coherent_types: [],

}

const getters = {
    isLoadingKindSelector: state => state.loading.kind, /** Проверяет, идет ли загрузка селектора типов опросов */
    isLoadingDocumentSelector: state => state.loading.document, /** Проверяет, идет ли загрузка селектора типов документов */
    isLoadingAnonymitySelector: state => state.loading.anonymity, /** Проверяет, идет ли загрузка селектора типов анонимности */
    isLoadingFieldTypeSelector: state => state.loading.field_type, /** Проверяет, идет ли загрузка селектора типов полей */
    isLoadingDateValueSelector: state => state.loading.date_value, /** Проверяет, идет ли загрузка селектора динамических типов дат */
    isLoadingCoherentSelector: state => state.loading.coherent, /** Проверяет, идет ли загрузка селектора когерентных типов */
    isLoadingAdminFieldsSelector: state => state.loading.admin_fields, /** Проверяет, идет ли загрузка селектора полей администратора */
    isLoadingAdminChoicesSelector: state => state.loading.admin_choices, /** Проверяет, идет ли загрузка селектора вариантов выбора администратора */
    isLoadingCreatorFieldsSelector: state => state.loading.creator_fields, /** Проверяет, идет ли загрузка селектора полей создателя */
    isLoadingCreatorChoicesSelector: state => state.loading.creator_choices, /** Проверяет, идет ли загрузка селектора вариантов выбора создателя */
    getKindSelector: state => state.selectors.kind, /** Возвращает селектор типов опросов */
    getDocumentSelector: state => state.selectors.document, /** Возвращает селектор типов документов */
    getAnonymitySelector: state => state.selectors.anonymity, /** Возвращает селектор типов анонимности */
    getFieldTypeSelector: state => state.selectors.field_type, /** Возвращает селектор типов полей */
    getDateValueSelector: state => state.selectors.date_value, /** Возвращает селектор динамических типов дат */
    getCoherentSelector: state => state.selectors.coherent, /** Возвращает селектор когерентных типов */
    getAdminFieldsSelector: state => state.selectors.admin_fields, /** Возвращает селектор полей для администратора */
    getAdminChoicesSelector: state => state.selectors.admin_choices, /** Возвращает селектор вариантов выбора для администратора */
    getCreatorFieldsSelector: state => state.selectors.creator_fields, /** Возвращает селектор полей для создателя */
    getCreatorChoicesSelector: state => state.selectors.creator_choices, /** Возвращает селектор вариантов выбора для создателя */
}

const mutations = {
    setKindSelector: (state, data) => {
      /**
       * Устанавливает данные селектора типов опросов
       */
        state.selectors.kind = data
    },
    setDocumentSelector: (state, data) => {
      /**
       * Устанавливает данные селектора типов документов
       */
        state.selectors.document = data
    },
    setAnonymitySelector: (state, data) => {
      /**
       * Устанавливает данные селектора типов анонимности
       */
        state.selectors.anonymity = data
    },
    setFieldTypeSelector: (state, data) => {
      /**
       * Устанавливает данные селектора типов полей
       */
        state.selectors.field_type = data
    },
    setDateValueSelector: (state, data) => {
      /**
       * Устанавливает данные селектора динамических типов дат
       */
        state.selectors.date_value = data
    },
    setCoherentSelector: (state, data) => {
      /**
       * Устанавливает данные селектора когерентных типов
       */
        state.selectors.coherent = data
    },
    setAdminFieldsSelector: (state, data) => {
      /**
       * Устанавливает данные селектора полей администратора
       */
        state.selectors.admin_fields = data
    },
    setAdminChoicesSelector: (state, data) => {
      /**
       * Устанавливает данные селектора вариантов выбора администратора
       */
        state.selectors.admin_choices = data
    },
    setCreatorFieldsSelector: (state, data) => {
      /**
       * Устанавливает данные селектора полей создателя
       */
        state.selectors.creator_fields = data
    },
    setCreatorChoicesSelector: (state, data) => {
      /**
       * Устанавливает данные селектора вариантов выбора создателя
       */
        state.selectors.creator_choices = data
    },
    setIsLoadingDocumentSelector: state => state.loading.document = true,
    setIsLoadingKindSelector: state => state.loading.kind = true,
    setIsLoadingAnonymitySelector: state => state.loading.anonymity = true,
    setIsLoadingFieldTypeSelector: state => state.loading.field_type = true,
    setIsLoadingDateValueSelector: state => state.loading.date_value = true,
    setIsLoadingCoherentSelector: state => state.loading.coherent = true,
    setIsLoadingAdminFieldsSelector: state => state.loading.admin_fields = true,
    setIsLoadingAdminChoicesSelector: state => state.loading.admin_choices = true,
    setIsLoadingCreatorFieldsSelector: state => state.loading.creator_fields = true,
    setIsLoadingCreatorChoicesSelector: state => state.loading.creator_choices = true,
    setIsNotLoadingKindSelector: state => state.loading.kind = false,
    setIsNotLoadingAnonymitySelector: state => state.loading.anonymity = false,
    setIsNotLoadingDocumentSelector: state => state.loading.document = false,
    setIsNotLoadingFieldTypeSelector: state => state.loading.field_type = false,
    setIsNotLoadingDateValueSelector: state => state.loading.date_value = false,
    setIsNotLoadingCoherentSelector: state => state.loading.coherent = false,
    setIsNotLoadingAdminFieldsSelector: state => state.loading.admin_fields = false,
    setIsNotLoadingAdminChoicesSelector: state => state.loading.admin_choices = false,
    setIsNotLoadingCreatorFieldsSelector: state => state.loading.creator_fields = false,
    setIsNotLoadingCreatorChoicesSelector: state => state.loading.creator_choices = false,
}

const actions = {
    loadKindSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор типов опросов
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            choices.CHOICES_SELECTOR.KIND_TYPE(),
            {commit, getters},
            'Kind',
            finalizer,
            force
        )
    },
    loadDocumentTypeSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор типов документов
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            choices.CHOICES_SELECTOR.DOCUMENT_TYPE(),
            {commit, getters},
            'Document',
            finalizer,
            force
        )
    },
    loadAnonymitySelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор типов анонимности
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            choices.CHOICES_SELECTOR.ANONYMITY_TYPE(),
            {commit, getters},
            'Anonymity',
            finalizer,
            force
        )
    },
    loadFieldTypeSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор типов полей
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            choices.CHOICES_SELECTOR.FIELD_TYPE(),
            {commit, getters},
            'FieldType',
            finalizer,
            force
        )
    },

    loadDateTypesSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор динамических типов дат
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            choices.CHOICES_SELECTOR.DATE_DYNAMIC_TYPE(),
            {commit, getters},
            'DateValue',
            finalizer,
            force
        )
    },
    loadCoherentSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор когерентных типов
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            choices.CHOICES_SELECTOR.COHERENT_TYPE(),
            {commit, getters},
            'Coherent',
            finalizer,
            force
        )
    },
    loadFieldsAdminSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор полей для администратора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            selectors.SELECTORS.ADMIN.FIELDS(),
            {commit, getters},
            'AdminFields',
            finalizer,
            force
        )
    },
    loadChoicesAdminSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор вариантов выбора для администратора
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            selectors.SELECTORS.ADMIN.CHOICES(),
            {commit, getters},
            'AdminChoices',
            finalizer,
            force
        )
    },
    loadFieldsCreatorSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор полей для создателя
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            selectors.SELECTORS.CREATOR.FIELDS(),
            {commit, getters},
            'CreatorFields',
            finalizer,
            force
        )
    },
    loadChoicesCreatorSelector: ({commit, getters}, {finalizer, force}={finalizer: ()=>{}, force: false}) => {
      /**
       * Загружает селектор вариантов выбора для создателя
       * @param {Function} commit - Функция для вызова мутаций
       * @param {Function} getters - Геттеры Vuex
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {boolean} force - Принудительная перезагрузка
       */
        loadSelector(
            selectors.SELECTORS.CREATOR.CHOICES(),
            {commit, getters},
            'CreatorChoices',
            finalizer,
            force
        )
    },

    loadStageFieldFile: ({commit}, {id, key = null, finalizer, catcher}) => {
      /**
       * Загружает файл поля этапа
       * @param {Function} commit - Функция для вызова мутаций
       * @param {number} id - Идентификатор файла
       * @param {string} key - Ключ файла
       * @param {Function} finalizer - Функция-обработчик успешного ответа
       * @param {Function} catcher - Функция-обработчик ошибок
       */
        let get = {}
        if (key) get['key'] = key
        sendGetRequest(
            selectors.SELECTORS.FILE.DOWNLOAD(id, get),
            finalizer ? finalizer : () => {},
            catcher ? catcher : () => {},
        )
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
